import { render } from "./NewsSnippetBlock.vue?vue&type=template&id=29005304"
import script from "./NewsSnippetBlock.vue?vue&type=script&lang=js"
export * from "./NewsSnippetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__